(function () {
  if (window.mlpLandingInit) return;
  window.mlpLandingInit = true;
  function youtubeId(url) {
    if (!url) return '';
    var match = url.match(/(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|shorts\/))([A-Za-z0-9_-]{11})/);
    return match ? match[1] : '';
  }

  function openModal(modal, url) {
    var inner = modal.querySelector('[data-mlp-modal-inner]');
    if (!inner) return;
    var id = youtubeId(url);
    inner.innerHTML = '';
    if (id) {
      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube.com/embed/' + id + '?autoplay=1';
      iframe.title = 'Video';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
      iframe.allowFullscreen = true;
      inner.appendChild(iframe);
    } else if (url) {
      var video = document.createElement('video');
      video.src = url;
      video.controls = true;
      video.autoplay = true;
      inner.appendChild(video);
    }
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeModal(modal) {
    var inner = modal.querySelector('[data-mlp-modal-inner]');
    if (inner) inner.innerHTML = '';
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-mlp-video]');
    if (trigger) {
      var slide = trigger.closest('[data-mlp-about-slide]');
      if (slide && !slide.classList.contains('is-active')) return;
      var url = trigger.getAttribute('data-video-url');
      var modal = document.querySelector('[data-mlp-modal]');
      if (url && modal) {
        event.preventDefault();
        openModal(modal, url);
      }
      return;
    }

    var close = event.target.closest('[data-mlp-modal-close]');
    if (close) {
      closeModal(close.closest('[data-mlp-modal]'));
      return;
    }

    if (event.target.hasAttribute('data-mlp-modal')) {
      closeModal(event.target);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-mlp-modal].is-open').forEach(closeModal);
  });

  function unlockFaqAnswers() {
    document.querySelectorAll('.mlp-faq .accordion__block').forEach(function (block) {
      if (block.classList.contains('open')) {
        block.style.height = 'auto';
      } else {
        block.style.height = '';
      }
    });
  }

  function initAboutCarousel(root) {
    var row = root.querySelector('.mlp-about__row');
    var viewport = root.querySelector('.mlp-about__viewport');
    if (!row || !viewport) return;
    var prev = root.querySelector('[data-mlp-about-prev]');
    var next = root.querySelector('[data-mlp-about-next]');
    var animating = false;
    var pointerId = null;
    var startX = 0;
    var dragX = 0;
    var dragged = false;
    var endTimer = 0;

    function slides() {
      return Array.prototype.slice.call(row.children);
    }

    function middleIndex() {
      return Math.floor(slides().length / 2);
    }

    function stepSize() {
      var slide = row.children[0];
      if (!slide) return 0;
      var gap = parseFloat(window.getComputedStyle(row).gap) || 0;
      return slide.getBoundingClientRect().width + gap;
    }

    function playMode(el) {
      return el.getAttribute('data-play-mode') || root.getAttribute('data-play-mode') || 'inline';
    }

    function pauseMedia(el) {
      var video = el.querySelector('video');
      var iframe = el.querySelector('iframe[data-mlp-yt]');
      el.classList.remove('is-playing');
      if (video) {
        video.pause();
        video.controls = false;
        video.removeAttribute('controls');
      }
      if (iframe) iframe.remove();
    }

    function sourceUrl(el) {
      var ytId = el.getAttribute('data-yt-id');
      if (ytId) return 'https://www.youtube.com/watch?v=' + ytId;
      return el.getAttribute('data-video-url') || '';
    }

    function playInline(el, fromUser) {
      if (!fromUser && el.classList.contains('is-playing')) return;

      var video = el.querySelector('video');
      var ytId = el.getAttribute('data-yt-id');

      if (video) {
        video.muted = !fromUser;
        video.loop = true;
        video.playsInline = true;
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
        video.controls = true;
        video.setAttribute('controls', '');
        if (video.preload !== 'auto') video.preload = 'auto';

        var start = function () {
          if (!el.classList.contains('is-active')) return;
          var attempt = video.play();
          if (attempt && attempt.then) {
            attempt.then(function () {
              if (el.classList.contains('is-active')) el.classList.add('is-playing');
              else video.pause();
            }).catch(function () {
              if (!el.classList.contains('is-active')) return;
              video.muted = true;
              video.play().then(function () {
                if (el.classList.contains('is-active')) el.classList.add('is-playing');
              }).catch(function () {
                el.classList.remove('is-playing');
              });
            });
          } else {
            el.classList.add('is-playing');
          }
        };

        if (video.readyState >= 2) {
          start();
        } else {
          video.addEventListener('canplay', start, { once: true });
          try { video.load(); } catch (err) {}
        }
        return;
      }

      if (ytId) {
        var card = el.querySelector('.mlp-about-card');
        if (!card) return;
        var iframe = card.querySelector('iframe[data-mlp-yt]');
        if (!iframe) {
          iframe = document.createElement('iframe');
          iframe.setAttribute('data-mlp-yt', '');
          iframe.title = 'Video';
          iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
          iframe.setAttribute('allowfullscreen', '');
          card.insertBefore(iframe, card.querySelector('.mlp-about-card__scrim'));
        }
        iframe.src = 'https://www.youtube.com/embed/' + ytId + '?autoplay=1&mute=1&playsinline=1&controls=1&rel=0';
        el.classList.add('is-playing');
      }
    }

    function playActive(el, fromUser) {
      var mode = playMode(el);
      var url = sourceUrl(el);

      if (mode === 'new_tab') {
        if (fromUser && url) window.open(url, '_blank', 'noopener');
        return;
      }

      playInline(el, !!fromUser);
    }

    function syncPlayback() {
      slides().forEach(function (el) {
        if (el.classList.contains('is-active')) playActive(el, false);
        else pauseMedia(el);
      });
    }

    function setActive() {
      var nodes = slides();
      var mid = middleIndex();
      var activeIndex = '0';
      nodes.forEach(function (el, i) {
        var isActive = i === mid;
        el.classList.toggle('is-active', isActive);
        if (isActive) activeIndex = el.getAttribute('data-index') || String(i);
      });
      root.querySelectorAll('[data-mlp-about-dot]').forEach(function (dot) {
        dot.classList.toggle('swiper-pagination-bullet-active', dot.getAttribute('data-mlp-about-dot') === activeIndex);
      });
      syncPlayback();
    }

    function commit(steps) {
      var count = Math.abs(steps);
      var i;
      if (steps > 0) {
        for (i = 0; i < count; i += 1) {
          if (row.firstElementChild) row.appendChild(row.firstElementChild);
        }
      } else if (steps < 0) {
        for (i = 0; i < count; i += 1) {
          if (row.lastElementChild) row.insertBefore(row.lastElementChild, row.firstElementChild);
        }
      }
      row.style.transition = 'none';
      row.style.transform = '';
      row.classList.remove('is-animating');
      setActive();
      animating = false;
      dragX = 0;
    }

    function go(steps) {
      if (animating || !steps) return;
      var size = stepSize();
      var count = slides().length;
      if (!size || !count) return;
      steps = ((steps + count) % count);
      if (steps > count / 2) steps -= count;
      if (!steps) return;

      animating = true;
      row.classList.add('is-animating');
      slides().forEach(pauseMedia);
      var upcoming = slides()[(middleIndex() + steps + count) % count];
      var upcomingVideo = upcoming && upcoming.querySelector('video');
      if (upcomingVideo && upcomingVideo.readyState < 2) {
        upcomingVideo.muted = true;
        upcomingVideo.preload = 'auto';
        try { upcomingVideo.load(); } catch (err) {}
      }
      row.style.transition = 'transform 0.22s cubic-bezier(0.22, 1, 0.36, 1)';
      row.style.transform = 'translate3d(' + (-size * steps) + 'px, 0, 0)';

      function finish(event) {
        if (event && event.target !== row) return;
        row.removeEventListener('transitionend', finish);
        window.clearTimeout(endTimer);
        commit(steps);
      }

      row.addEventListener('transitionend', finish);
      endTimer = window.setTimeout(finish, 280);
    }

    function stepsTo(index) {
      var nodes = slides();
      var mid = middleIndex();
      var currentPos = -1;
      nodes.forEach(function (el, i) {
        if (el.getAttribute('data-index') === String(index)) currentPos = i;
      });
      if (currentPos < 0) return 0;
      var delta = currentPos - mid;
      var len = nodes.length;
      if (delta > len / 2) delta -= len;
      if (delta < -len / 2) delta += len;
      return delta;
    }

    function rotateTo(index) {
      go(stepsTo(index));
    }

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });

    root.querySelectorAll('[data-mlp-about-dot]').forEach(function (dot) {
      dot.addEventListener('click', function () {
        rotateTo(dot.getAttribute('data-mlp-about-dot'));
      });
    });

    row.addEventListener('click', function (event) {
      if (dragged) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      var slide = event.target.closest('[data-mlp-about-slide]');
      if (!slide) return;
      if (!slide.classList.contains('is-active')) {
        event.preventDefault();
        event.stopPropagation();
        rotateTo(slide.getAttribute('data-index'));
        return;
      }
      if (event.target.closest('video, iframe')) return;
      if (slide.classList.contains('is-playing')) return;
      playActive(slide, true);
    });

    viewport.addEventListener('pointerdown', function (event) {
      if (animating || event.button) return;
      if (event.target.closest('.mlp-about__arrow')) return;
      if (event.target.closest('.is-playing, video, iframe')) return;
      pointerId = event.pointerId;
      startX = event.clientX;
      dragX = 0;
      dragged = false;
      row.classList.add('is-dragging');
      row.style.transition = 'none';
      try { viewport.setPointerCapture(pointerId); } catch (err) {}
    });

    viewport.addEventListener('pointermove', function (event) {
      if (pointerId === null || event.pointerId !== pointerId) return;
      dragX = event.clientX - startX;
      if (Math.abs(dragX) > 6) dragged = true;
      row.style.transform = 'translate3d(' + dragX + 'px, 0, 0)';
    });

    function endPointer(event) {
      if (pointerId === null) return;
      if (event && event.pointerId !== pointerId) return;
      pointerId = null;
      row.classList.remove('is-dragging');
      var size = stepSize();
      var threshold = Math.max(40, size * 0.18);
      if (dragX <= -threshold) {
        go(1);
      } else if (dragX >= threshold) {
        go(-1);
      } else if (dragX) {
        animating = true;
        row.classList.add('is-animating');
        row.style.transition = 'transform 0.3s ease';
        row.style.transform = 'translate3d(0, 0, 0)';
        function snapEnd(evt) {
          if (evt && evt.target !== row) return;
          row.removeEventListener('transitionend', snapEnd);
          window.clearTimeout(endTimer);
          row.classList.remove('is-animating');
          row.style.transition = 'none';
          row.style.transform = '';
          animating = false;
          dragX = 0;
        }
        row.addEventListener('transitionend', snapEnd);
        endTimer = window.setTimeout(snapEnd, 360);
      }
    }

    viewport.addEventListener('pointerup', endPointer);
    viewport.addEventListener('pointercancel', endPointer);

    document.addEventListener('click', function (event) {
      if (!dragged) return;
      if (!event.target.closest('[data-mlp-about]')) return;
      event.preventDefault();
      event.stopPropagation();
      dragged = false;
    }, true);

    setActive();
  }

  function initHeroPlayback(root) {
    var toggle = root.querySelector('[data-mlp-hero-toggle]');
    if (!toggle || root.dataset.mlpHeroReady) return;
    root.dataset.mlpHeroReady = 'true';
    var videos = root.querySelectorAll('video');
    if (!videos.length) {
      toggle.hidden = true;
      return;
    }

    function visibleVideo() {
      var found = null;
      videos.forEach(function (video) {
        var media = video.closest('.mlp-hero__media');
        if (!media) return;
        if (window.getComputedStyle(media).display === 'none') return;
        found = video;
      });
      return found || videos[0];
    }

    function sync() {
      var video = visibleVideo();
      var playing = video && !video.paused;
      toggle.classList.toggle('is-playing', playing);
      toggle.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
    }

    videos.forEach(function (video) {
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
    });
    toggle.addEventListener('click', function () {
      var video = visibleVideo();
      if (!video) return;
      if (video.paused) video.play();
      else video.pause();
    });
    sync();
  }

  function paintReasonsMedia(stage, image, video) {
    if (!stage) return;
    var currentImage = stage.getAttribute('data-current-image') || '';
    var currentVideo = stage.getAttribute('data-current-video') || '';
    if (currentImage === (image || '') && currentVideo === (video || '')) return;
    stage.setAttribute('data-current-image', image || '');
    stage.setAttribute('data-current-video', video || '');
    stage.innerHTML = '';

    var youtube = video && video.match(/(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|shorts\/))([A-Za-z0-9_-]{11})/);
    if (youtube) {
      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube.com/embed/' + youtube[1] + '?autoplay=1&mute=1&loop=1&playlist=' + youtube[1];
      iframe.title = 'Video';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
      iframe.allowFullscreen = true;
      stage.appendChild(iframe);
      return;
    }

    if (video) {
      var el = document.createElement('video');
      el.autoplay = true;
      el.muted = true;
      el.loop = true;
      el.playsInline = true;
      if (image) el.poster = image;
      var source = document.createElement('source');
      source.src = video;
      source.type = 'video/mp4';
      el.appendChild(source);
      stage.appendChild(el);
      return;
    }

    if (image) {
      var img = document.createElement('img');
      img.src = image;
      img.alt = '';
      stage.appendChild(img);
    }
  }

  function syncReasonsMedia(section) {
    var stage = section.querySelector('[data-mlp-reasons-stage]');
    if (!stage) return;
    var open = section.querySelector('.accordion__container.open');
    var image = open && open.getAttribute('data-image');
    var video = open && open.getAttribute('data-video');
    if (!open || (!image && !video)) {
      image = stage.getAttribute('data-default-image');
      video = stage.getAttribute('data-default-video');
    }
    paintReasonsMedia(stage, image, video);
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('.mlp-reasons-acc .accordion__toggle');
    if (!toggle) return;
    var section = toggle.closest('[data-mlp-reasons]');
    if (!section) return;
    requestAnimationFrame(function () {
      syncReasonsMedia(section);
    });
  });

  function initLanding() {
    unlockFaqAnswers();
    document.querySelectorAll('[data-mlp-reasons]').forEach(syncReasonsMedia);
    document.querySelectorAll('[data-mlp-about]').forEach(function (root) {
      if (root.dataset.mlpAboutReady) return;
      root.dataset.mlpAboutReady = 'true';
      initAboutCarousel(root);
    });
    document.querySelectorAll('.mlp-hero').forEach(initHeroPlayback);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLanding);
  } else {
    initLanding();
  }

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-mlp-about]').forEach(function (root) {
      root.dataset.mlpAboutReady = '';
    });
    event.target.querySelectorAll('.mlp-hero').forEach(function (root) {
      root.dataset.mlpHeroReady = '';
    });
    initLanding();
  });
})();
